import React from 'react';
import { Button, Popover, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import styled from '@emotion/styled';

const PickerContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    minWidth: 300,
    maxWidth: 340,
}));

const PickerTitle = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
}));

const PickerHelper = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
    marginBottom: theme.spacing(0.5),
}));

const PickerActions = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
}));

const ActivitySummaryPicker = ({
    open,
    anchorEl,
    onClose,
    title,
    helperText,
    value,
    onChange,
    minDate,
    maxDate,
    views,
    openTo,
    format,
    pickerLabel,
    primaryLabel = 'Generate summary',
    onSubmit,
    submitDisabled = false,
    children,
}) => {
    const invalidValue = !value || !dayjs.isDayjs(value) || !value.isValid();
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <PickerContainer>
                <PickerTitle variant="subtitle1" component="h2">{title}</PickerTitle>
                <PickerHelper variant="body2">{helperText}</PickerHelper>
                <DatePicker
                    label={pickerLabel}
                    views={views}
                    openTo={openTo}
                    format={format}
                    value={value}
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={onChange}
                    slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                />
                {children}
                <PickerActions>
                    <Button type="button" onClick={onClose} color="inherit">Cancel</Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={onSubmit}
                        disabled={submitDisabled || invalidValue}
                    >
                        {primaryLabel}
                    </Button>
                </PickerActions>
            </PickerContainer>
        </Popover>
    );
};

export default ActivitySummaryPicker;
